import React, { useState, useEffect } from "react";
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { FaEdit, FaPlus, FaPlusCircle, FaTrash } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const AssignProjects = () => {
  const { t } = useTranslation();

  return (
    <>
      <Card
        title={t("project_permissions")}
        className="InputForms_container mt-4"
      >
        <div className="grid">
          <div className="col-8">
            <div className="settings-text-cover">
              <span>{t("projects")}</span>
            </div>
          </div>
          <div className="col-3">
            <div className="settings-text-cover">
              <div className="text-center">{t("permission")}</div>
            </div>
            <div className="add-edit flex justify-content-between mt-3">
              <p>
                {t("edit")} <br />
                {t("devices")}{" "}
              </p>
              <p>
                {t("create")} <br /> {t("reports")}{" "}
              </p>
              <p>
                {t("view")} <br /> {t("data")}{" "}
              </p>
            </div>
          </div>
          <div className="col-1"></div>
        </div>

        {/* LOOP ON GRID BELOW */}
        <div className="grid row align-items-center">
          <div className="col-8">
            <div className="name">
              <p>Project 1</p>
            </div>
          </div>
          <div className="col-3">
            <div className="status flex  justify-content-between">
              <div className="status-green ml-4"></div>
              <div className="status-red ml-4"></div>
              <div className="status-green mx-4"></div>
            </div>
          </div>
          <div className="col-1">
            <div className="status flex  justify-content-center">
              <FaTrash className="mx-3" />
            </div>
          </div>
        </div>
        <div className="grid row align-items-center">
          <div className="col-8">
            <div className="name">
              <p>Project 2</p>
            </div>
          </div>
          <div className="col-3">
            <div className="status flex  justify-content-between">
              <div className="status-green ml-4"></div>
              <div className="status-red ml-4"></div>
              <div className="status-green mx-4"></div>
            </div>
          </div>
          <div className="col-1">
            <div className="status flex  justify-content-center">
              <FaTrash className="mx-3" />
            </div>
          </div>
        </div>
        <div className="grid row align-items-center">
          <div className="col-8">
            <div className="name">
              <p>Project 3</p>
            </div>
          </div>
          <div className="col-3">
            <div className="status flex  justify-content-between">
              <div className="status-green ml-4"></div>
              <div className="status-red ml-4"></div>
              <div className="status-green mx-4"></div>
            </div>
          </div>
          <div className="col-1">
            <div className="status flex  justify-content-center">
              <FaTrash className="mx-3" />
            </div>
          </div>
        </div>
      </Card>
      <div className="grid justify-content-end save-cover mt-4 pr-5">
        <div className="col-4 flex align-items-center">
          <button>{t("abort")}</button>
          <button>{t("save")}</button>
          <div className="ml-auto mr-4">
            <FaPlusCircle fontSize={"20px"} color="green" />
          </div>
        </div>
      </div>
    </>
  );
};

export default AssignProjects;
